import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { HomePage } from './pages/HomePage.js';
import { t } from './i18n/index.js';

/**
 * L'ecran de jeu embarque le moteur de rendu 3D, soit plusieurs centaines de
 * kilo-octets. Il n'est charge qu'au moment ou le joueur ouvre une partie :
 * la page d'accueil reste legere.
 */
const GamePage = lazy(async () => ({ default: (await import('./pages/GamePage.js')).GamePage }));
import { LoginPage } from './pages/LoginPage.js';
import { RegisterPage } from './pages/RegisterPage.js';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage.js';
import { ResetPasswordPage } from './pages/ResetPasswordPage.js';
import { ProfilePage } from './pages/ProfilePage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import { RequireAuth } from './ui/RequireAuth.js';

/**
 * Table de routage.
 * Les adresses sont en francais : elles font partie de l'interface visible.
 * Les ecrans de jeu et d'administration viendront s'ajouter ici au fil des lots.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <HomePage /> },
      {
        path: 'demonstration',
        element: (
          <Suspense fallback={<p role="status">{t().app.loading}</p>}>
            <GamePage />
          </Suspense>
        ),
      },
      { path: 'connexion', element: <LoginPage /> },
      { path: 'inscription', element: <RegisterPage /> },
      { path: 'mot-de-passe-oublie', element: <ForgotPasswordPage /> },
      { path: 'reinitialiser-mot-de-passe', element: <ResetPasswordPage /> },
      {
        path: 'profil',
        element: (
          <RequireAuth>
            <ProfilePage />
          </RequireAuth>
        ),
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
